<template>
    <Navbar />
    <router-view v-slot="{ Component }">
        <transition name="fade">
            <suspense timeout="0">
                <template #default>
                    <component :is="Component" :key="$route.path" />
                    <!-- <AllProduct /> -->
                </template>
                <template #fallback>
                    <LoadAllProduct />
                </template>
            </suspense>
        </transition>
    </router-view>
    <Foot />
</template>

<script setup>
import Foot from '@/Components/Section/Foot.vue';
import Navbar from '@/Components/Section/Navbar.vue';
import LoadAllProduct from '@/Components/Skeleton/LoadAllProduct.vue';
</script>

<style>
.fade-enter-active {
    transition: opacity 1s ease;
}

.fade-leave-active {
    transition: opacity 0s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
